export default __webpack_public_path__ + "static/media/mode-64.f5a7af65.svg";